import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import {
  CheckCircle as CheckCircleIcon,
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon
} from '@material-ui/icons'
import { toast } from 'react-toastify'
import axios from 'axios'
import { useHistory } from 'react-router-dom'

const LeadConvertModal = ({ open, lead, onClose, onConvert }) => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const handleConvert = async () => {
    setLoading(true)
    try {
      const response = await axios.post(`/api/company/leads/${lead._id}/convert`)
      
      if (response.data.success) {
        toast.success('Lead successfully converted to customer!')
        onConvert(response.data.data)
        
        // Optionally navigate to the new customer
        setTimeout(() => {
          if (response.data.data.customer?._id) {
            history.push(`/customers/${response.data.data.customer._id}`)
          }
        }, 1500)
      }
    } catch (error) {
      console.error('Error converting lead:', error)
      toast.error(error.response?.data?.error || 'Failed to convert lead')
    } finally {
      setLoading(false)
    }
  }

  if (!lead) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircleIcon color="success" />
          <Typography variant="h6">Convert Lead to Customer</Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent dividers>
        <Alert severity="info" style={{ marginBottom: 16 }}>
          Converting this lead will create a new customer with the information below.
        </Alert>

        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Customer Information Preview
        </Typography>
        
        <List>
          <ListItem>
            <ListItemIcon>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Company Name"
              secondary={lead.companyName}
            />
          </ListItem>
          
          <ListItem>
            <ListItemIcon>
              <LocationIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Address"
              secondary={lead.address}
            />
          </ListItem>
          
          {lead.contactName && (
            <ListItem>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Primary Contact"
                secondary={lead.contactName}
              />
            </ListItem>
          )}
          
          {lead.contactEmail && (
            <ListItem>
              <ListItemIcon>
                <EmailIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Email"
                secondary={lead.contactEmail}
              />
            </ListItem>
          )}
          
          {lead.contactPhone && (
            <ListItem>
              <ListItemIcon>
                <PhoneIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Phone"
                secondary={lead.contactPhone}
              />
            </ListItem>
          )}
        </List>

        <Divider style={{ margin: '16px 0' }} />

        <Alert severity="warning">
          This action cannot be undone. The lead status will be permanently changed to "converted".
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button 
          onClick={handleConvert} 
          variant="contained" 
          color="success"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : <CheckCircleIcon />}
        >
          {loading ? 'Converting...' : 'Convert to Customer'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LeadConvertModal